import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'mobx-react';

import BaseEntriesStore from './stores/BaseEntriesStore'
import BrespaAnalyseStore from './stores/BrespaAnalyseStore'
import HalbfertigAnalyseStore from './stores/HalbfertigAnalyseStore'
import OrtbetonAnalyseStore from './stores/OrtbetonAnalyseStore'
/*import ParkraumEntriesStore from './stores/ParkraumEntriesStore'
import VerbundEntriesStore from './stores/VerbundEntriesStore'
import GussasphaltWartungStore from './stores/GussasphaltWartungStore'
import OS811WartungStore from './stores/OS811WartungStore'
import ChartModel from './models/ChartModel'*/
import App from './App';
import './index.css';
import  'bootstrap/dist/css/bootstrap.css';
import 'jquery/jquery.min'
//import 'popper.js/dist/popper.min'
import 'bootstrap/dist/js/bootstrap.min'

const stores = {
    baseDataStore:BaseEntriesStore,
    brespaAnalyseStore:BrespaAnalyseStore,
    halbfertigAnalyseStore:HalbfertigAnalyseStore,
    ortbetonAnalyseStore:OrtbetonAnalyseStore,
    /*parkraumDataStore:ParkraumEntriesStore,
    verbundDataStore:VerbundEntriesStore,
    gaWartungsStore:GussasphaltWartungStore,
    os811WartungsStore:OS811WartungStore,
    chartModel:ChartModel*/
};

ReactDOM.render(
    <Provider {...stores}>
        <App className="container" />
    </Provider>,
    document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js